/* Abstract Feels — theme JS (vanilla, no dependencies) */
(function(){
  'use strict';

  /* ---------- Mobile nav ---------- */
  function initMobileNav(){
    var burger=document.querySelector('[data-burger]');
    var nav=document.querySelector('[data-mobile-nav]');
    var overlay=document.querySelector('[data-overlay]');
    if(!burger||!nav) return;
    function open(){nav.classList.add('open');overlay&&overlay.classList.add('open');document.documentElement.classList.add('nav-open');}
    function close(){nav.classList.remove('open');overlay&&overlay.classList.remove('open');document.documentElement.classList.remove('nav-open');}
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    burger.addEventListener('click',open);
    overlay&&overlay.addEventListener('click',close);
    var c=nav.querySelector('[data-mnav-close]');
    c&&c.addEventListener('click',close);
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(){
    document.querySelectorAll('[data-hero]').forEach(function(hero){
      var slides=hero.querySelectorAll('.hero__slide');
      var dots=hero.querySelectorAll('.hero__dots button');
      if(slides.length<2){ if(slides[0])slides[0].classList.add('active'); return; }
      var i=0,timer;
      function show(n){
        i=(n+slides.length)%slides.length;
        slides.forEach(function(s,k){s.classList.toggle('active',k===i);});
        dots.forEach(function(d,k){d.classList.toggle('active',k===i);});
      }
      function go(d){show(i+d);reset();}
      function reset(){clearInterval(timer);timer=setInterval(function(){show(i+1);},5000);}
      hero.querySelectorAll('[data-hero-prev]').forEach(function(b){b.addEventListener('click',function(){go(-1);});});
      hero.querySelectorAll('[data-hero-next]').forEach(function(b){b.addEventListener('click',function(){go(1);});});
      dots.forEach(function(d,k){d.addEventListener('click',function(){show(k);reset();});});
      show(0);reset();
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(){
    var root=document.querySelector('[data-product]');
    if(!root) return;
    var data=root.querySelector('[data-product-json]');
    var product; try{product=JSON.parse(data.textContent);}catch(e){return;}
    var variants=product.variants||[];
    var form=root.querySelector('[data-product-form]');
    var idInput=root.querySelector('[data-variant-id]');
    var priceEl=root.querySelector('[data-price]');
    var addBtn=root.querySelector('[data-add-btn]');
    var skuEl=root.querySelector('[data-sku]');
    var qtyInput=root.querySelector('[data-qty]');
    var meta=product.meta||{};
    var selected={};

    // init selected options from first available variant (or first)
    var initV=variants.find(function(v){return String(v.id)===idInput.value;})||variants.filter(function(v){return v.available;})[0]||variants[0];
    if(initV){ (initV.options||[]).forEach(function(o,idx){selected[idx]=o;}); }

    function money(cents){
      var v=(cents/100).toFixed(2).replace('.',',');
      return v+' lei';
    }
    function match(){
      return variants.find(function(v){
        return (v.options||[]).every(function(o,idx){return selected[idx]===o;});
      });
    }
    // poza mare / video mare
    function mainTo(src,video){
      var mi=root.querySelector('[data-main-img]'), mv=root.querySelector('[data-main-video]');
      if(video&&mv){
        if(mi)mi.hidden=true;
        mv.src=video;mv.hidden=false;var p=mv.play();if(p&&p.catch)p.catch(function(){});
        return;
      }
      if(mv&&!mv.hidden){mv.pause();mv.hidden=true;mv.removeAttribute('src');mv.load();}
      if(mi){mi.hidden=false;if(src)mi.src=src;}
    }
    // galerie: pozele cu același alt formează un grup (ex. „…, în stoc: S – Alb”)
    var thumbs=[].slice.call(root.querySelectorAll('[data-thumb]'));
    var groupSize={};
    thumbs.forEach(function(t){var g=t.getAttribute('data-group');groupSize[g]=(groupSize[g]||0)+1;});
    var variantGroups={};
    variants.forEach(function(v){var a=v.featured_image&&v.featured_image.alt;if(a&&groupSize[a]>1)variantGroups[a]=true;});
    function showThumbs(v){
      if(!thumbs.length)return;
      var g=v&&v.featured_image&&v.featured_image.alt;
      var list;
      if(g&&variantGroups[g]){list=thumbs.filter(function(t){var tg=t.getAttribute('data-group');return tg===g||(t.hasAttribute('data-video')&&!variantGroups[tg]);});}
      else if(Object.keys(variantGroups).length){list=thumbs.filter(function(t){return !variantGroups[t.getAttribute('data-group')];});}
      else{list=thumbs.length<=8?thumbs.slice():thumbs.slice(0,4);}
      thumbs.forEach(function(t){t.hidden=list.indexOf(t)<0;t.classList.remove('active');});
      if(list[0])list[0].classList.add('active');
      if(list[0]&&!(v&&v.featured_image)){mainTo(list[0].getAttribute('data-thumb'),null);}
    }
    function render(){
      // mark chosen pills/swatches; valorile care nu se combină cu opțiunile de dinainte se ascund
      root.querySelectorAll('[data-opt]').forEach(function(el){
        var idx=+el.getAttribute('data-opt-index');
        var val=el.getAttribute('data-opt');
        var on=selected[idx]===val;
        el.classList.toggle('sel',on);
        el.setAttribute('aria-pressed',on?'true':'false');
        var lbl=root.querySelector('[data-opt-current="'+idx+'"]');
        if(on&&lbl)lbl.textContent=val;
        if(idx>0){
          el.hidden=!variants.some(function(v){
            var o=v.options||[];
            if(o[idx]!==val)return false;
            for(var k=0;k<idx;k++){if(o[k]!==selected[k])return false;}
            return true;
          });
        }
      });
      var v=match();
      showThumbs(v);
      var m=(v&&meta[v.id])||{};
      var camp=root.querySelector('[data-camp-comanda]');
      if(camp){
        var dinStoc=!m.pc;
        camp.hidden=dinStoc;
        var ta=camp.querySelector('textarea');if(ta)ta.disabled=dinStoc;
      }
      // livrare / retur / disponibilitate după varianta aleasă
      function show(sel,on){var e=root.querySelector(sel);if(e)e.hidden=!on;}
      show('[data-ship-stoc]',!m.pc);
      show('[data-ship-comanda]',!!m.pc);
      var ld=root.querySelector('[data-ship-lead]');if(ld&&m.lead)ld.textContent=m.lead;
      show('[data-retur-std]',!(product.personalizat&&m.pc));
      show('[data-retur-pers]',!!(product.personalizat&&m.pc));
      var av=root.querySelector('[data-avail]');
      if(av)av.textContent=!v?'—':(!v.available?'stoc epuizat':(m.pc?'pe comandă':'în stoc'));
      // cantitate: piesele unicat nu au selector; la celelalte maximul = stocul
      if(qtyInput){
        var max=m.max||0;
        if(max>0){qtyInput.max=max;}else{qtyInput.removeAttribute('max');}
        if(max>0&&(parseInt(qtyInput.value,10)||1)>max)qtyInput.value=max;
        if(max===1)qtyInput.value=1;
        show('[data-qty-wrap]',max!==1);
        show('[data-unicat]',max===1&&!!(v&&v.available));
      }
      if(v){
        idInput.value=v.id;
        if(priceEl){
          var html=money(v.price);
          if(v.compare_at_price&&v.compare_at_price>v.price){html+=' <s>'+money(v.compare_at_price)+'</s>';}
          priceEl.innerHTML=html;
        }
        if(skuEl)skuEl.textContent=v.sku||'';
        show('[data-sku-wrap]',!!v.sku);
        if(v.featured_image&&v.featured_image.src){
          var mi=root.querySelector('[data-main-img]');
          if(mi){var src=v.featured_image.src;mainTo(src+(src.indexOf('?')>-1?'&':'?')+'width=1000',null);mi.alt=v.featured_image.alt||mi.alt;}
        }
        if(addBtn){
          addBtn.disabled=!v.available;
          addBtn.querySelector('[data-add-label]').textContent=v.available?'Adaugă în coș':'Stoc epuizat';
        }
      }else if(addBtn){
        addBtn.disabled=true;
        addBtn.querySelector('[data-add-label]').textContent='Indisponibil';
      }
      // bara fixă de pe telefon copiază prețul și starea butonului principal
      var sp=root.querySelector('[data-sticky-price]'),sb=root.querySelector('[data-sticky-btn]');
      if(sp&&v)sp.textContent=money(v.price);
      if(sb&&addBtn){sb.disabled=addBtn.disabled;sb.querySelector('[data-sticky-label]').textContent=addBtn.querySelector('[data-add-label]').textContent;}
    }
    root.querySelectorAll('[data-opt]').forEach(function(el){
      el.addEventListener('click',function(){
        if(el.classList.contains('soldout'))return;
        var idx=+el.getAttribute('data-opt-index');
        selected[idx]=el.getAttribute('data-opt');
        if(!match()){
          // combinația nu există: alegem cea mai apropiată variantă care are valoarea apăsată
          var val=selected[idx];
          var cands=variants.filter(function(v){return (v.options||[])[idx]===val;});
          var best=null,bestScore=-1;
          cands.forEach(function(v){
            var s=(v.available?100:0);
            (v.options||[]).forEach(function(o,k){if(k!==idx&&selected[k]===o)s++;});
            if(s>bestScore){bestScore=s;best=v;}
          });
          if(best){(best.options||[]).forEach(function(o,k){selected[k]=o;});}
        }
        render();
      });
    });
    render();

    // bara fixă: apare doar după ce butonul principal a ieșit din ecran (în sus)
    var sticky=root.querySelector('[data-sticky-buy]');
    if(sticky&&addBtn&&'IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        var e=en[0];var show=!e.isIntersecting&&e.boundingClientRect.top<0;
        sticky.classList.toggle('show',show);sticky.setAttribute('aria-hidden',show?'false':'true');
        var b=sticky.querySelector('[data-sticky-btn]');if(b)b.tabIndex=show?0:-1;
      }).observe(addBtn);
    }

    // gallery thumbs
    root.querySelectorAll('[data-thumb]').forEach(function(t){
      t.addEventListener('click',function(){
        mainTo(t.getAttribute('data-thumb'),t.getAttribute('data-video'));
        root.querySelectorAll('[data-thumb]').forEach(function(x){x.classList.remove('active');});
        t.classList.add('active');
      });
    });

    // qty
    function clampQty(n){var mx=parseInt(qtyInput.max,10);n=Math.max(1,n||1);return mx>0?Math.min(mx,n):n;}
    root.querySelectorAll('[data-qty-btn]').forEach(function(b){
      b.addEventListener('click',function(){
        var d=+b.getAttribute('data-qty-btn');
        qtyInput.value=clampQty((parseInt(qtyInput.value,10)||1)+d);
      });
    });
    if(qtyInput)qtyInput.addEventListener('change',function(){qtyInput.value=clampQty(parseInt(qtyInput.value,10));});
  }

  /* ---------- Tabs ---------- */
  function initTabs(){
    document.querySelectorAll('[data-tabs]').forEach(function(root){
      var tabs=root.querySelectorAll('[data-tab]');
      var panels=root.querySelectorAll('[data-panel]');
      tabs.forEach(function(t){
        t.addEventListener('click',function(){
          var k=t.getAttribute('data-tab');
          tabs.forEach(function(x){x.classList.toggle('active',x===t);});
          panels.forEach(function(p){p.classList.toggle('active',p.getAttribute('data-panel')===k);});
        });
      });
    });
  }

  /* ---------- Collection: mobile filter toggle + sort ---------- */
  function initCollection(){
    var toggle=document.querySelector('[data-filter-toggle]');
    var side=document.querySelector('[data-col-side]');
    if(toggle&&side){toggle.addEventListener('click',function(){side.classList.toggle('open');});}
    var sort=document.querySelector('[data-sort]');
    if(sort){sort.addEventListener('change',function(){
      var url=new URL(window.location.href);
      url.searchParams.set('sort_by',sort.value);
      url.searchParams.delete('page');
      window.location.href=url.toString();
    });}
  }

  /* ---------- Cart qty change (native form) ---------- */
  function initCart(){
    document.querySelectorAll('[data-cart-qty]').forEach(function(inp){
      inp.addEventListener('change',function(){
        var f=inp.closest('form');if(f)f.submit();
      });
    });
  }


  /* ---------- Povestea: florile din dreapta sus cresc până la limita textului ---------- */
  function initStoryDoodle(){
    var PROF=[0.235,0.292,0.319,0.328,0.33,0.339,0.351,0.358,0.429,0.499,0.506,0.505,0.474,0.858,0.858,0.843,0.835,0.847,0.848,0.845,0.843,0.834,0.818,0.791,0.758,0.825,0.85,0.864,0.873,0.873,0.867,0.844,0.837,0.844,0.847,0.847,0.818,0.824,0.851,0.876,0.881,0.878,0.87,0.914,0.977,0.989,0.987,0.967,0.904,0.903,0.886,0.761,0.764,0.754,0.74,0.652,0.396,0.391,0.366,0.3], AR=1.2876, GAP=6, MAX=150, MIN=50;
    document.querySelectorAll('.story').forEach(function(card){
      var img=card.querySelector('.story__doodle.tr'), body=card.querySelector('.story__body');
      if(!img||!body) return;
      function fit(){
        if(window.innerWidth<=760){ img.style.width=''; return; }
        var c=card.getBoundingClientRect(), lines=[];
        var tw=document.createTreeWalker(body,NodeFilter.SHOW_TEXT), n;
        while((n=tw.nextNode())){ if(!n.data.trim()) continue; var r=document.createRange(); r.selectNodeContents(n);
          var rs=r.getClientRects(); for(var i=0;i<rs.length;i++) lines.push({fr:c.right-rs[i].right, t:rs[i].top-c.top, b:rs[i].bottom-c.top}); }
        body.querySelectorAll('.btn').forEach(function(btn){var bb=btn.getBoundingClientRect(); lines.push({fr:c.right-bb.right,t:bb.top-c.top,b:bb.bottom-c.top});});
        function hits(W){ var H=W*AR, N=PROF.length;
          for(var k=0;k<lines.length;k++){ var L=lines[k], y0=Math.max(0,L.t-GAP), y1=Math.min(H,L.b+GAP); if(y0>=y1) continue;
            for(var i=Math.floor(y0/H*N); i<=Math.min(N-1,Math.floor(y1/H*N)); i++){ if(PROF[i]*W > L.fr-GAP) return true; } }
          return false; }
        var best=MIN; for(var W=MAX; W>=MIN; W-=2){ if(!hits(W)){ best=W; break; } }
        img.style.width=best+'px';
      }
      fit();
      var t; window.addEventListener('resize',function(){ clearTimeout(t); t=setTimeout(fit,120); });
      if(document.fonts&&document.fonts.ready) document.fonts.ready.then(fit);
    });
  }

  document.addEventListener('DOMContentLoaded',function(){
    initMobileNav();initHero();initProduct();initTabs();initCollection();initCart();initStoryDoodle();
  });
})();
